import buildFullName from './buildFullName';

type BasicUserType = {
  firstName: string;
  lastName: string;
};

export default (a: BasicUserType, b: BasicUserType) =>
  `${buildFullName(a.firstName, a.lastName)}`
    .toLowerCase()
    .localeCompare(`${buildFullName(b.firstName, b.lastName)}`.toLowerCase());
